<script lang="ts" setup>
import { ref } from "vue";
import type { EditorProps } from "./editor.types";
import { VisuallyHiddenInput } from "components/VisuallyHidden";
import { useEditor } from "./useEditor";

const props = withDefaults(defineProps<EditorProps>(), { value: "" });

const containerRef = ref<HTMLElement | null>(null);
const rootRef = ref<HTMLElement | null>(null);

const { figureClasses, bodyClasses, formName, formValue } = useEditor({
  props,
  containerRef,
  rootRef,
});
</script>

<template>
  <figure ref="rootRef" part="base" :class="figureClasses">
    <slot name="header" />

    <div ref="containerRef" part="body" class="e-editor-body" :class="bodyClasses" />

    <visually-hidden-input v-if="formName" :name="formName" :value="formValue" />
  </figure>
</template>

<style>
:host {
  display: contents;
}

.e-editor-body .monaco-editor,
.e-editor-body .monaco-editor.monaco-editor-background,
.e-editor-body .monaco-editor .margin,
.e-editor-body .monaco-editor .overflow-guard {
  background: transparent !important;
  background-color: transparent !important;
}

.e-editor-body .monaco-editor .lines-content {
  padding-left: 24px !important;
  padding-right: 24px !important;
}
</style>
